import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { AttributeResource } from '@df/catalog/attribute/attribute.resource';

@Pipe({
    name: 'attributeLabel',
    standalone: true
})
export class AttributeLabelPipe implements PipeTransform {
    constructor(private attributeLabelPipeService: AttributeLabelPipeService) {}
    transform(code: string) {
        return this.attributeLabelPipeService.execute(code);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AttributeLabelPipeService {
    constructor(private attributeResource: AttributeResource) {}

    execute(code: string): string | undefined {
        return this.attributeResource.getExisting(code)?.data?.label;
    }
}
